import { SampleBreakdownUnit, SampleCategories } from 'api';
import { SelectField, TextField, useFieldArray, useFormContext } from 'form';
import { Box, Button, IconButton, Stack, Typography } from 'ui';
import { Add, Close } from 'ui/icons';

const nameOptions = Object.values(SampleCategories).map((value) => ({
  label: value.replace(/_/g, ' '),
  value,
}));

const unitOptions = Object.values(SampleBreakdownUnit).map((value) => ({
  label: value.replace(/_/g, ' '),
  value,
}));

export const DefaultBreakdownFormFields = () => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'breakdown',
  });

  return (
    <Stack gap={2}>
      <Typography variant="body1" fontWeight="bold">
        Breakdown
      </Typography>

      {fields.map((field, index) => (
        <Stack key={field.id} direction="row" alignItems="flex-top" gap={2}>
          <SelectField name={`breakdown.${index}.name`} options={nameOptions} label="Name" required />

          <TextField name={`breakdown.${index}.value`} label="Value" required />

          <SelectField name={`breakdown.${index}.unit`} options={unitOptions} label="Unit" required />

          <Box>
            <IconButton onClick={() => remove(index)} data-test-id="remove-breakdown-item">
              <Close />
            </IconButton>
          </Box>
        </Stack>
      ))}

      <Button
        variant="secondary"
        sx={{ alignSelf: 'end' }}
        startIcon={<Add />}
        onClick={() => append({ name: '', unit: '', value: '' })}
      >
        Add Breakdown Item
      </Button>
    </Stack>
  );
};
